import React, { useState, useEffect } from 'react';
import { FiTwitter, FiFacebook, FiInstagram } from 'react-icons/fi';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const launchDate = new Date('2024-12-31').getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = launchDate - now;

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex gap-4 justify-center mb-8">
      {Object.entries(timeLeft).map(([unit, value]) => (
        <motion.div 
          key={unit}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="bg-primary-shade1 p-4 rounded-lg border-2 border-primary-shade2"
        >
          <div className="text-3xl font-bold text-primary-shade5">{value}</div>
          <div className="text-sm text-text-muted">{unit}</div>
        </motion.div>
      ))}
    </div>
  );
};

const ComingSoon = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      toast.success('Thanks for subscribing! We\'ll notify you when we launch.');
      setEmail('');
      setIsLoading(false);
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-shade1 to-primary-shade2 flex items-center justify-center relative overflow-hidden">
      {/* Animated background elements */}
      <motion.div 
        animate={{ rotate: 360 }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
        className="absolute w-96 h-96 rounded-full border-4 border-primary/20 -top-48 -left-48"
      />
      <motion.div 
        animate={{ rotate: -360 }}
        transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
        className="absolute w-64 h-64 rounded-full border-4 border-primary/20 -bottom-32 -right-32"
      />

      <div className="relative z-10 max-w-2xl w-full px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white rounded-3xl shadow-3d p-8 text-center"
        >
          {/* Book illustration */}
          <motion.div 
            animate={{ y: [-10, 10, -10] }}
            transition={{ duration: 4, repeat: Infinity }}
            className="mb-8 mx-auto w-32 h-48 bg-primary-shade1 rounded-lg shadow-lg transform rotate-6 relative"
          >
            <div className="absolute inset-0 bg-primary-shade3 rounded-lg transform -rotate-3" />
            <div className="absolute inset-0 bg-primary-shade1 rounded-lg transform rotate-1" />
          </motion.div>

          <h1 className="text-5xl font-nunito font-bold mb-4 bg-gradient-to-r from-primary to-primary-shade5 bg-clip-text text-transparent">
            Chapter Two
          </h1>
          <p className="text-xl text-text-muted mb-6 font-nunito">
            We're writing the next chapter in book discovery
          </p>

          <motion.div
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="mb-8"
          >
            <h2 className="text-3xl font-bold text-primary-shade5">Coming Soon</h2>
          </motion.div>

        </motion.div>
      </div>
    </div>
  );
};

export default ComingSoon;